import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import './divider.sass'

@Component
export class Divider extends Vue {

  render (h: CreateElement) {
    return (
      <hr class='divider' />
    )
  }

}
